// import {handleActions} from 'redux-actions';
import * as Actions from './actions';
import {initialState} from '../store/initialState';

export const QuestionReducer = (state = initialState.post, action)  => {
    switch (action.type) {
        case Actions.BACK_TO_HOME:
            return {
                ...state,
                ...action.payload
            };
        case Actions.UPDATE_VALUE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case Actions.RESET_VALUE:
            return {
                ...action.payload
            };
        default:
            return state
    }
};
